<template>
    <div class="ManualOrderUsageFeeDetails">
		<div class="summary_bag">
			<div class="summary_complete_bag">
				<!-- 时间 -->
				<el-form
					:inline="true"
					label-width="120px"
					ref="selectForm"
					:model="selectForm"
				>
					<el-form-item
						label="选择分部门"
						prop="departmentValue"
						v-if="
							UserInfo.system < 3 ||
								UserInfo.superDepartmentName === '客服部' ||
								(UserInfo.system === 5 &&
									UserInfo.superDepartmentName ===
										'常规客服部')
						"
					>
						<el-select
							clearable
							v-model="selectForm.departmentValue"
							placeholder="请选择"
							value-key="rid"
							@change="selectChange($event, 'groupList')"
						>
							<el-option
								v-for="item in departmentList"
								:key="item.rid"
								:label="item.departmentName"
								:value="item"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item
						label="选择组"
						prop="groupValue"
						v-if="
							UserInfo.system < 4 ||
								UserInfo.superDepartmentName === '客服部' ||
								(UserInfo.system === 5 &&
									UserInfo.superDepartmentName ===
										'常规客服部')
						"
					>
						<el-select
							clearable
							v-model="selectForm.groupValue"
							placeholder="请选择"
							value-key="rid"
							@change="selectChange($event, 'staffList')"
						>
							<el-option
								v-for="item in groupList"
								:key="item.rid"
								:label="item.groupName"
								:value="item"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item
						label="选择员工"
						prop="staffValue"
						v-if="
							UserInfo.system < 5 ||
								UserInfo.superDepartmentName === '客服部' ||
								(UserInfo.system === 5 &&
									UserInfo.superDepartmentName ===
										'常规客服部')
						"
					>
						<el-select
							clearable
							v-model="selectForm.staffValue"
							placeholder="请选择"
							value-key="rid"
							@change="selectChange($event)"
						>
							<el-option
								v-for="item in staffList"
								:key="item.rid"
								:label="item.roleUserName"
								:value="item"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="买家账号等级" prop="value">
						<el-select
							clearable
							v-model="selectForm.BuyerAccountLevel"
							placeholder="请选择"
						>
							<el-option
								v-for="(item, index) in List"
								:key="index"
								:label="item.gradeName"
								:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="信用卡账号等级" prop="value">
						<el-select
							clearable
							v-model="selectForm.CreditCardLevel"
							placeholder="请选择"
						>
							<el-option
								v-for="(item, index) in List2"
								:key="index"
								:label="item.gradeName"
								:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="买家地址等级" prop="value">
						<el-select
							clearable
							v-model="selectForm.BuyerAddressClass"
							placeholder="请选择"
						>
							<el-option
								v-for="(item, index) in List3"
								:key="index"
								:label="item.gradeName"
								:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="下单IP地址等级" prop="value">
						<el-select
							clearable
							v-model="selectForm.SingleIPlevel"
							placeholder="请选择"
						>
							<el-option
								v-for="(item, index) in List4"
								:key="index"
								:label="item.gradeName"
								:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="账号状态" prop="mark">
						<el-select v-model="selectForm.AccountStatus" clearable>
							<!-- <el-option label="全部" value="0"></el-option> -->
							<el-option label="活跃中" value="1"></el-option>
							<el-option label="已封禁" value="0"></el-option>
							<el-option label="待回收" value="2"></el-option>
							<el-option label="已回收" value="3"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="领用状态" prop="isTranslation">
						<el-select v-model="selectForm.RecipientsState" clearable>
							<!-- <el-option label="全部" :value="1"></el-option> -->
							<el-option label="已领用" :value="1"></el-option>
							<el-option label="未领用" :value="0"></el-option>
						</el-select>
					</el-form-item><br>
                    <el-form-item>
                        <span slot="label">
                            <span class="span-box">
                                <p>国家</p>
                                <el-tooltip style="diaplay:inline" effect="dark" content="此国家为下单账号所属国家，及该国家账号还有多少" placement="top">
                                    <i class="el-icon-question" />
                                </el-tooltip>
                            </span>
                        </span>
						<el-radio-group v-model="selectForm.country">
							<el-row type="flex">
								<el-radio label="US">美国 ( {{ countryList.US }} )</el-radio>
								<el-radio label="CA">加拿大 ( {{ countryList.CA }} )</el-radio>
								<el-radio label="MX">墨西哥 ( {{ countryList.MX }} )</el-radio>
							</el-row>
							<el-row type="flex" style="margin: 10px 0">
								<el-radio label="GB">英国 ( {{ countryList.GB }} )</el-radio>
								<el-radio label="DE">德国 ( {{ countryList.DE }} )</el-radio>
								<el-radio label="FR">法国 ( {{ countryList.FR }} )</el-radio>
								<el-radio label="IT">意大利 ( {{ countryList.IT }} )</el-radio>
								<el-radio label="ES">西班牙 ( {{ countryList.ES }} )</el-radio>
								<el-radio label="NL">荷兰 ( {{ countryList.NL }} )</el-radio>
								<el-radio label="SE">瑞典 ( {{ countryList.SE }} )</el-radio>
								<el-radio label="PL">波兰 ( {{ countryList.PL }} )</el-radio>
								<el-radio label="SA">沙特阿拉伯 ( {{ countryList.SA }} )</el-radio>
								<el-radio label="AE">阿联酋 ( {{ countryList.AE }} )</el-radio>
							</el-row>
							<el-row type="flex">
								<el-radio label="JP">日本 ( {{ countryList.JP }} )</el-radio>
								<el-radio label="AU">澳大利亚 ( {{ countryList.AU }} )</el-radio>
								<el-radio label="SG">新加坡 ( {{ countryList.SG }} )</el-radio>
							</el-row>
							<!-- <el-radio v-for="(item,index) in country" :key="index" :label="item.value">{{item.name}}</el-radio> -->
						</el-radio-group>
                    </el-form-item><br>
					<el-form-item label="时间筛选类型" prop="isTranslation">
						<el-radio-group v-model="selectForm.timeType">
                            <el-radio :label="1">申请时间</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="开始日期" prop="startTime">
						<el-date-picker
							v-model="selectForm.startTime"
							align="right"
							type="datetime"
							placeholder="选择开始日期"
							:picker-options="pickerOptions"
							value-format="yyyy-MM-dd HH:mm:ss"
							style="width:200px;"
						></el-date-picker>
					</el-form-item>
					<el-form-item label="结束日期" prop="endTime">
						<el-date-picker
							v-model="selectForm.endTime"
							align="right"
							type="datetime"
							placeholder="选择结束日期"
							:picker-options="pickerOptions"
							value-format="yyyy-MM-dd HH:mm:ss"
							style="width:200px;"
						></el-date-picker>
					</el-form-item>
					<el-form-item label=" " prop="input">
						<el-input
							class="custom-input"
							v-model="selectForm.input"
							placeholder="全字段搜索"
							style="width:464px;"
							clearable
						></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary"
							@click="Search"
							>搜索</el-button
						>
						<el-button
							type="primary"
							 @click="searchReset"
							>重置</el-button
						>
					</el-form-item>
					<!-- </div> -->
				</el-form>
			</div>
			<div class="summary_content">
				<div class="summary_list">
					<!-- 头部 -->
					<el-table
						:data="summarylist"
						style="width: 100%"
						v-loading="load_data"
						element-loading-text="拼命加载中"
						border
						:header-cell-style="iscenter"
						stripe
					>
						<el-table-column
							label="序号"
							prop="id"
							width="80"
							align="center"
						></el-table-column>
						<el-table-column
							label="买家账号组合方案"
							align="center"
							prop="buyerAccountCombinationName"
						>
						</el-table-column>
						<el-table-column 
							prop="buyerAccountInformation.gradeName"
							label="买家账号等级"
							align="center">
						</el-table-column>
						<el-table-column
							prop="creditCardAccountInformation.gradeName"
							label="信用卡账号等级"
							align="center"
						></el-table-column>
						<el-table-column
							prop="buyerAddressInformation.gradeName"
							label="买家地址等级"
							align="center"
						></el-table-column>
						<el-table-column
							prop="orderIPAddressInformation.gradeName"
							label="下单IP地址等级"
							align="center"
						>
						</el-table-column>
						<el-table-column
							label="账号状态"
							align="center"
						>
							<template slot-scope="scope">
								<p v-if="scope.row.buyerAccountInformation.buyerAccountAccountStatus == 1" style="color:green">活跃中</p>
								<p v-else-if="scope.row.buyerAccountInformation.buyerAccountAccountStatus == 0" style="color:red">已封禁</p>
								<p v-else-if="scope.row.buyerAccountInformation.buyerAccountAccountStatus == 2" style="color:#feba07">待回收</p>
								<p v-else-if="scope.row.buyerAccountInformation.buyerAccountAccountStatus == 3">已回收</p>
							</template>
						</el-table-column>
						<el-table-column
							label="领用状态"
							align="center"
						>
							<template slot-scope="scope">
								<p v-if="scope.row.buyerAccountInformation.buyerAccountRequisitionStatus == 1">已领用</p>
								<p v-else-if="scope.row.buyerAccountInformation.buyerAccountRequisitionStatus == 0" style="color:#feba07">未领用</p>
							</template>
						</el-table-column>
						<el-table-column
							label="国家"
							align="center"
							prop="buyerAccountInformation.country"
						>
						</el-table-column>
						<el-table-column
							prop="roleName"
							label="使用人"
							align="center"
						>
						</el-table-column>
						<el-table-column
							prop="cost"
							label="费用(元)"
							align="center"
						>
						</el-table-column>
						<el-table-column
							prop="applicationTime"
							label="申请时间"
							align="center"
						>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<div class="summary_pagenum_block">
				<div class="block">
					<el-pagination
						@current-change="handleCurrentChange"
						:current-page="page"
					    :page-size="size"
						@size-change="handleSizeChange"
						:page-sizes="[10, 20, 50, 100]"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</div>
			</div>
		</div>  
    </div>
</template>

<script>
import { ajaxPost, Baseurl } from '../../../../api/api/api'
export default {
    name: 'ManualOrderUsageFeeDetails',
	data() {
		return {
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now()
				},
				shortcuts: [
					{
						text: '本月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate()
						},
					},
					{
						text: '上一月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate(-1)
						},
					},
					{
						text: '上两月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate(-2)
						},
					},
					{
						text: '上三月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate(-3)
						},
					},
				],
			},
			total: 0,
			page: 1,
			size: 20,
			staffId: '',
			companyId: 0,
			iscenter: {
				textAlign: 'center',
				background: '#f8f8f8',
				color: '#232323',
			},
			load_data: false,
			UserInfo: {},
            summarylist: [],
			selectForm: {
                timeType: '',
				startTime: '',
				endTime: '',
				input: '',
				departmentValue: {},
				groupValue: {},
				staffValue: {},
				BuyerAccountLevel: '',
				CreditCardLevel: '',
				BuyerAddressClass: '',
				AccountStatus: '',
				SingleIPlevel: '',
				RecipientsState: '',
				country: ''
			},
			List: [],
			List2: [],
			List3: [],
			List4: [],
			countryList: {},
            departmentList: [],
            groupList: [],
            staffList: [],
            country: [
                { value: 0, name: '美国', Referred: 'US' },
                { value: 1, name: '加拿大', Referred: 'CA' },
                { value: 2, name: '墨西哥', Referred: 'MX' },
                { value: 3, name: '英国', Referred: 'GB' },
                { value: 4, name: '德国', Referred: 'DE' },
                { value: 5, name: '法国', Referred: 'FR' },
                { value: 6, name: '意大利', Referred: 'IT' },
                { value: 7, name: '西班牙', Referred: 'ES' },
                { value: 8, name: '荷兰', Referred: 'NL' },
                { value: 9, name: '瑞典', Referred: 'SE' },
                { value: 10, name: '波兰', Referred: 'PL' },
                { value: 11, name: '沙特阿拉伯', Referred: 'SA' },
                { value: 12, name: '阿联酋', Referred: 'AE' },
                { value: 13, name: '日本', Referred: 'JP' },
                { value: 14, name: '澳大利亚', Referred:'AU' },
                { value: 15, name: '新加坡', Referred: 'SG' }

            ]
		}
	},
	created() {
        this.UserInfo = JSON.parse(localStorage.getItem('role'))
		this.init()
		this.selectSettings()
		this.AccountNumber()
		this.getUsageRecordList()
		if (
			this.UserInfo.system !== 5 &&
			this.UserInfo.superDepartmentName !== '运营部'
		) {
			this.operateWidth = 80
		}
	},
	methods: {
		// 查询各国买家账号数量
		AccountNumber() {
			const API = Baseurl + 'buyerAccountController/selectBuyerAccountCount'
			const paramsData = {
				companyId: this.companyId
			}
			ajaxPost(API,paramsData)
				.then((res) => {
					if(res.data.code === 200) {
						this.countryList = res.data.data
					}else {
						this.$message.error(res.data.data)
					}
				})
		},
		Search() {
			this.getUsageRecordList()
		},
		getUsageRecordList() {
			this.load_data = true;
            const API =  Baseurl + 'buyerAccountUsageRecordController/selectBuyerAccountUsageRecordList'
            const paramsData = {
				rid: this.staffId,       
                beginDate: this.selectForm.startTime,
				endDate: this.selectForm.endTime,
				buyerAccountRankId: this.selectForm.BuyerAccountLevel,
				creditCardRankId: this.selectForm.CreditCardLevel,
				buyerAddressRankId: this.selectForm.BuyerAddressClass,
				orderIPAddressRankId: this.selectForm.SingleIPlevel,
				buyerAccountAccountStatus: this.selectForm.AccountStatus,
				buyerAccountRequisitionStatus: this.selectForm.RecipientsState,
				timeType: this.selectForm.timeType,
				searchString: this.selectForm.input,
				page: this.page,
				size: this.size
            }
            ajaxPost(API,paramsData)
                .then((res) => {
					this.load_data = false
                    if( res.data.code === 200 ) {
						this.summarylist = res.data.data.list
						this.total = res.data.data.total
                    }else {
						this.$message.error(res.data.data)
					}
                })
		},
		selectSettings() {
			const API =  Baseurl + 'buyerAccountSettingController/selectBuyerAccountSettings'
			const paramsData = {
				companyId: 1                                         // 公司id
			}
			ajaxPost(API,paramsData)
				.then((res) => {
					console.log(res)
					if( res.data.code === 200 ) {
						this.List = res.data.data.buyerAccountSetting
						this.List2 = res.data.data.creditCardSetting
						this.List3 = res.data.data.buyerAddress
						this.List4 = res.data.data.orderIPAddressSetting
					}else {
						this.$message.error(res.data.data)
					}
				})
		},
		init() {
			const {
				rid,
				system,
				company_id: companyId,
				type: companyType,
				superDepartmentName,
			} = this.UserInfo
			this.companyId = companyId
			this.staffId = rid
			let type = ''
			if (companyType === 1) {
				type = 'branchCompany'
				if (
					superDepartmentName === '客服部' ||
					superDepartmentName === '常规客服部'
				) {
					type = 'sonCompany'
				}
			} else if (companyType === 2) {
				type = 'sonCompany'
			} else if (system < 3) {
				type = 'departmentList'
			} else if (system === 3) {
				type = 'groupList'
			} else if (system === 4) {
				type = 'staffList'
			} else {
				return
			}
			this.getNextPower(rid, system, type)
		},
		getNextPower(rid, system, type) {
			const API = Baseurl + 'roleController/selectNextInfoByRid'
			const paramsData = { rid, system, companyId: this.companyId }
			ajaxPost(API,paramsData)
				.then((res) => {
					const {
						data: { code, data },
					} = res
					if( code === 200 ){
						this[type] = data.next
					}
				})
				.catch((e) => {
					console.log(e)
				})
		},
		selectChange(event, type) {
			const { rid, system, company_id: companyId } = event
			companyId && (this.companyId = companyId)
			this.getNextPower(rid, system, type)
			if (type === 'sonCompany') {
				this.selectForm.sonCompany = {}
				this.selectForm.departmentValue = {}
				this.selectForm.groupValue = {}
				this.selectForm.staffValue = {}
				this.sonCompany = []
				this.departmentList = []
				this.groupList = []
				this.staffList = []
			} else if (type === 'departmentList') {
				this.selectForm.departmentValue = {}
				this.selectForm.groupValue = {}
				this.selectForm.staffValue = {}
				this.departmentList = []
				this.groupList = []
				this.staffList = []
			} else if (type === 'groupList') {
				this.selectForm.groupValue = {}
				this.selectForm.staffValue = {}
				this.groupList = []
				this.staffList = []
			} else if (type === 'staffList') {
				this.selectForm.staffValue = {}
				this.staffList = []
			}
			this.staffId = rid
		},
		searchReset() {
			this.selectForm.timeType = ''
			this.selectForm.startTime = ''
			this.selectForm.endTime = ''
			this.selectForm.input = ''
			this.selectForm.departmentValue = ''
			this.selectForm.groupValue = ''
			this.selectForm.staffValue = ''
			this.selectForm.BuyerAccountLevel = ''
			this.selectForm.CreditCardLevel = ''
			this.selectForm.BuyerAddressClass = ''
			this.selectForm.AccountStatus = ''
			this.selectForm.SingleIPlevel = ''
			this.selectForm.RecipientsState = ''
			this.selectForm.country = ''
			
			this.getUsageRecordList()
		},
        handleSizeChange(val) {
			this.size = val
			this.getUsageRecordList()
		},
		handleCurrentChange(val) {
			this.page = val
			this.getUsageRecordList()
		}
	},
}
</script>
<style lang="scss" scoped>
.ManualOrderUsageFeeDetails{
	width: 98%;
	// background: #F7F7F7;
	padding-bottom: 72px;
	.summary_bag {
		width: 98%;
		margin: auto;
		.summary_complete_bag {
			overflow: hidden;
            .span-box{
                display: flex;
                align-items: center;
                justify-content: flex-end;
                margin-top: 15px;
                .el-icon-question{
                    font-size: 14px;
                }
            }
		}
		.summary_pagenum {
			width: 99.6%;
			margin-bottom: 10px;
			overflow: hidden;
			background: #f5f5f5;
            display: flex;
            justify-content: flex-end;
            padding: 5px;
		}
		.summary_content {
			width: 100%;
			border: 1px solid #eee;
			overflow: hidden;
            .summary_list {

            }
		}
		.summary_pagenum_block {
			width: 1790px;
			padding: 20px;
			position: fixed;
			right: 0;
			bottom: 0;
			background: #fff;
			z-index: 999;
			.el-pagination {
				display: flex;
				justify-content: center;
			}
		}
	}
}
</style>